/**
 * Amazon Price Format & Variant Title Update
 */

(function() {
  'use strict';
  
  // Format price as Amazon style
  function formatPrice(element) {
    if (element.classList.contains('amazon-formatted')) return;
    
    var text = element.textContent.trim();
    var match = text.match(/([^\d.,]*?)([\d,]+)(\.\d{2})?/);
    
    if (!match) return;
    
    var symbol = match[1] || '';
    var whole = match[2].replace(/,/g, '');
    var decimal = match[3] || '';
    
    var html = '';
    if (symbol) html += '<span class="a-price-symbol">' + symbol + '</span>';
    html += '<span class="a-price-whole">' + whole + '</span>';
    if (decimal) html += '<span class="a-price-decimal">' + decimal + '</span>';
    
    element.innerHTML = html;
    element.classList.add('amazon-formatted');
  }
  
  function initPriceFormat() {
    var prices = document.querySelectorAll('.product__price .price__current .money[data-price]');
    prices.forEach(formatPrice);
  }
  
  // Update variant title from selected options
  function updateVariantTitle() {
    var variantTitleEl = document.querySelector('[data-variant-title]');
    if (!variantTitleEl) return;
    
    // Get all selected option values from the selects
    var selects = document.querySelectorAll('.options-selection__input-select');
    var selectedOptions = [];
    
    selects.forEach(function(select) {
      if (select.value && select.value !== 'not-selected') {
        var optionText = select.options[select.selectedIndex].text;
        if (optionText && optionText.trim() !== '') {
          selectedOptions.push(optionText.trim());
        }
      }
    });
    
    // Combine all selected options
    if (selectedOptions.length > 0) {
      var variantTitle = selectedOptions.join(' / ');
      variantTitleEl.textContent = variantTitle;
      variantTitleEl.style.display = '';
    } else {
      variantTitleEl.style.display = 'none';
    }
  }
  
  function initVariantTitle() {
    // Listen for changes on options-selection__input-select elements
    function setupSelectListeners() {
      var selects = document.querySelectorAll('.options-selection__input-select');
      selects.forEach(function(select) {
        // Check if already has listener
        if (select.dataset.variantTitleListener === 'true') return;
        select.dataset.variantTitleListener = 'true';
        
        select.addEventListener('change', function() {
          setTimeout(updateVariantTitle, 100);
          setTimeout(updateVariantTitle, 300);
          setTimeout(updateVariantTitle, 500);
        });
      });
    }
    
    // Setup listeners for existing selects
    setupSelectListeners();
    
    // Watch for new select elements being added
    var selectObserver = new MutationObserver(function() {
      setupSelectListeners();
    });
    selectObserver.observe(document.body, { childList: true, subtree: true });
    
    // Watch variant-selection component
    var variantSelection = document.querySelector('variant-selection[data-variant-selection]');
    if (variantSelection) {
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'variant') {
            setTimeout(updateVariantTitle, 100);
            setTimeout(updateVariantTitle, 300);
          }
        });
      });
      observer.observe(variantSelection, { 
        attributes: true, 
        attributeFilter: ['variant'] 
      });
    }
    
    // Watch variant input
    var variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (variantInput) {
      var inputObserver = new MutationObserver(function() {
        setTimeout(updateVariantTitle, 100);
      });
      inputObserver.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    }
    
    // Listen for clicks on variant options
    document.addEventListener('click', function(e) {
      if (e.target.closest('.options-selection__input-select') ||
          e.target.closest('.options-selection__select-wrapper') ||
          e.target.closest('[data-variant-option-value]') || 
          e.target.closest('.options-selection__option-value')) {
        setTimeout(updateVariantTitle, 200);
        setTimeout(updateVariantTitle, 400);
      }
    }, true);
    
    // Listen for custom events
    document.addEventListener('variant:change', function() {
      setTimeout(updateVariantTitle, 100);
    });
    document.addEventListener('product:variant-change', function() {
      setTimeout(updateVariantTitle, 100);
    });
    
    // Poll for changes
    setInterval(function() {
      updateVariantTitle();
    }, 500);
    
    // Initial update
    setTimeout(updateVariantTitle, 500);
    setTimeout(updateVariantTitle, 1000);
  }

  // Store original textContent setters
  const originalSetters = new WeakMap();
  
  // Function to convert price to unit price
  function convertToUnitPrice(priceElement, totalPriceText, quantity) {
    if (!totalPriceText || !quantity || quantity < 1) {
      return totalPriceText; // Return original if can't convert
    }
    
    // Extract numeric value from price string
    const priceMatch = totalPriceText.match(/[\d,]+\.?\d*/);
    if (!priceMatch) {
      return totalPriceText;
    }

    // Remove commas and convert to number
    const totalPrice = parseFloat(priceMatch[0].replace(/,/g, ''));
    
    if (isNaN(totalPrice) || totalPrice <= 0) {
      return totalPriceText;
    }
    
    // Calculate unit price
    const unitPrice = totalPrice / quantity;

    if (isNaN(unitPrice) || unitPrice <= 0) {
      return totalPriceText;
    }

    // Format unit price (preserve original format)
    let formattedUnitPrice;
    if (totalPriceText.includes('$')) {
      formattedUnitPrice = '$' + unitPrice.toFixed(2);
    } else if (totalPriceText.includes('€')) {
      formattedUnitPrice = '€' + unitPrice.toFixed(2);
    } else if (totalPriceText.includes('£')) {
      formattedUnitPrice = '£' + unitPrice.toFixed(2);
    } else {
      formattedUnitPrice = unitPrice.toFixed(2);
    }

    return formattedUnitPrice;
  }

  // Function to get quantity for a price element
  function getQuantityForPrice(priceElement) {
    const priceInfoWrapper = priceElement.closest('.lb-qty-selector-price-info-wrapper');
    if (!priceInfoWrapper) {
      return 1;
    }
    
    const discountInfoWrapper = priceInfoWrapper.closest('.lb-qty-selector-discount-info-wrapper');
    if (!discountInfoWrapper) {
      return 1;
    }
    
    const quantityTextElement = discountInfoWrapper.querySelector('.lb-qty-selector-quantity-text');
    if (!quantityTextElement) {
      return 1;
    }
    
    const quantityText = quantityTextElement.textContent.trim();
    const quantityMatch = quantityText.match(/\d+/);
    
    return quantityMatch ? parseInt(quantityMatch[0]) : 1;
  }

  // Function to intercept price element updates
  function interceptPriceElement(priceElement) {
    // Skip if already intercepted
    if (priceElement.dataset.unitPriceIntercepted === 'true') {
      return;
    }
    
    // Mark as intercepted
    priceElement.dataset.unitPriceIntercepted = 'true';
    
    // Store original textContent descriptor
    const descriptor = Object.getOwnPropertyDescriptor(Node.prototype, 'textContent') || 
                       Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'textContent');
    
    if (!descriptor) {
      return;
    }
    
    // Create custom setter
    const customSetter = function(value) {
      // Check if this is a price element we care about
      if (this.classList.contains('money') && 
          this.closest('.lb-qty-selector-discounted-price-text')) {
        
        const priceText = String(value).trim();
        
        // Check if it looks like a total price (not already a unit price)
        const storedOriginal = this.dataset.originalTotal;
        let shouldConvert = true;
        
        if (storedOriginal) {
          const currentNum = parseFloat(priceText.replace(/[^\d.]/g, ''));
          const storedNum = parseFloat(storedOriginal.replace(/[^\d.]/g, ''));
          
          // If current is much smaller than stored, it's already a unit price
          if (currentNum < storedNum * 0.8) {
            shouldConvert = false;
            // Use stored original for conversion
            value = storedOriginal;
          } else {
            // It's a new total price - update stored
            this.dataset.originalTotal = priceText;
          }
        } else {
          // First time - store as original
          this.dataset.originalTotal = priceText;
        }
        
        if (shouldConvert) {
          const quantity = getQuantityForPrice(this);
          const unitPrice = convertToUnitPrice(this, value, quantity);
          
          // Call original setter with unit price
          if (descriptor.set) {
            descriptor.set.call(this, unitPrice);
          } else {
            this.textContent = unitPrice;
          }
          return;
        }
      }
      
      // For non-price elements or already converted prices, use original setter
      if (descriptor.set) {
        descriptor.set.call(this, value);
      } else {
        this.textContent = value;
      }
    };
    
    // Override textContent for this element
    Object.defineProperty(priceElement, 'textContent', {
      get: function() {
        return descriptor.get ? descriptor.get.call(this) : this.textContent;
      },
      set: customSetter,
      configurable: true
    });
  }

  // Function to find and intercept all price elements
  function interceptAllPrices() {
    const priceElements = document.querySelectorAll('.lb-qty-selector-discounted-price-text .money');
    priceElements.forEach(interceptPriceElement);
  }

  // Function to watch for new price elements
  function watchForNewPrices() {
    const observer = new MutationObserver(function(mutations) {
      let foundNew = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              // Check if it's a price element or contains one
              if (node.classList && node.classList.contains('money') && 
                  node.closest('.lb-qty-selector-discounted-price-text')) {
                interceptPriceElement(node);
                foundNew = true;
              } else if (node.querySelector) {
                const priceEl = node.querySelector('.lb-qty-selector-discounted-price-text .money');
                if (priceEl) {
                  interceptPriceElement(priceEl);
                  foundNew = true;
                }
              }
            }
          });
        }
      });
      
      if (foundNew) {
        // Also check all prices again in case we missed any
        setTimeout(interceptAllPrices, 100);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Initialize
  function init() {
    // Intercept existing prices
    interceptAllPrices();
    
    // Watch for new prices
    watchForNewPrices();
    
    // Initialize price formatting
    initPriceFormat();
    
    // Initialize variant title
    initVariantTitle();
    
    // Retry after delays
    setTimeout(interceptAllPrices, 500);
    setTimeout(interceptAllPrices, 1500);
    setTimeout(interceptAllPrices, 3000);
    
    setTimeout(initPriceFormat, 500);
    
    window.addEventListener('load', function() {
      setTimeout(interceptAllPrices, 500);
      setTimeout(initPriceFormat, 500);
    });
  }

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Watch for new price elements
  var priceObserver = new MutationObserver(function() {
    setTimeout(initPriceFormat, 50);
  });
  priceObserver.observe(document.body, { 
    childList: true, 
    subtree: true, 
    characterData: true,
    attributes: true,
    attributeFilter: ['class']
  });
})();
